<template>
  <div class="market-list-section">
    <!-- 海报+文章+朋友圈神器+节点关怀  图文混排 左侧是文字，右侧是图片 -->
    <div class="market-text-image-area">
      <!-- 有图片时,左文右图,无图时文字独占一行 -->
      <div :style="`width: ${item.src ? '3.64rem' : '100%'}`">
        <!-- 顶部推荐/必转标签 + 标题 -->
        <MarketTitle :item="item" />
        <p class="text-ellipsis left-text">{{ item.desc }}</p>
      </div>
      <img v-if="item.src" :src="item.src" class="right-img" alt="图片" />
    </div>

    <!-- 朋友圈神器的文章类型独占一行 -->
    <div v-if="item.article?.title" class="market-article-row">
      <img v-if="item.article?.cover" class="article-img" :src="item.article?.cover" />
      <span class="article-title text-ellipsis">{{ item.article?.title }}</span>
    </div>

    <!-- 底部标签组 -->
    <div v-if="item.tags?.length" class="market-bottom-tags">
      <ThemeTag v-for="(tagItem, tagIndex) in item.tags" :key="tagIndex" class="market-bottom-tag-item flex-center">
        {{ `#${tagItem || ''}` }}
      </ThemeTag>
    </div>

    <!-- 发布/截止时间 -->
    <p v-if="item.dateTime" class="market-date-text">{{ item.dateTime }}</p>
  </div>
</template>

<script setup lang="tsx">
  import { ThemeTag } from '@shared/components/theme-components';

  defineProps<{
    item: any;
  }>();

  // 顶部推荐/必转标签 + 标题
  const MarketTitle = ({ item }: any) => {
    return (
      <div class="market-title-row text-ellipsis">
        {item.isRecommend && <span class="market-top-tag">推荐</span>}
        {item.Must && <span class="market-top-tag">必转</span>}
        <span class="market-row-title">{item.title}</span>
      </div>
    );
  };
</script>

<style scoped lang="less">
  // 顶部推荐标签
  .market-top-tag {
    padding: 1px 5px;
    margin-right: 0.1rem;
    font-size: 0.22rem;
    color: #fff;
    background-color: #ed4444;
    border-radius: 0.08rem 0;
    font-weight: normal;
  }
  // 列表项区块
  .market-list-section {
    display: flex;
    flex-direction: column;

    .market-title-row {
      line-height: 0.42rem;
      margin-bottom: 0.1rem;

      // 标题
      .market-row-title {
        line-height: 0.42rem;
        font-size: 0.3rem;
        font-weight: 500;
        color: #333;
        word-break: break-all;
      }
    }

    .market-text-image-area {
      display: flex;
      width: 6.2rem;
      margin-bottom: 0.2rem;

      .left-text {
        line-height: 0.4rem;
        max-height: 1.2rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #666;
        word-break: break-all;
      }

      .right-img {
        width: 2rem;
        height: 1.5rem;
        margin-left: 0.6rem;
        border-radius: 0.1rem;
        object-fit: cover;
      }
    }

    // 图片
    .market-img-row {
      width: 6.2rem;
      height: 1.63rem;
      background: #000;
      border-radius: 0.08rem;
      object-fit: cover;
    }

    //  文章行
    .market-article-row {
      display: flex;
      align-items: center;
      width: 6.2rem;
      height: 1rem;
      background: #f5f5f5;
      border-radius: 0.04rem;

      .article-img {
        width: 0.8rem;
        height: 0.8rem;
        margin-right: 0.2rem;
      }

      .article-title {
        height: 0.33rem;
        line-height: 0.33rem;
        font-family: PingFangSC-Regular, 'PingFang SC';
        font-size: 0.24rem;
        font-weight: 400;
        color: #333;
      }
    }

    .market-bottom-tags {
      display: flex;
      flex-wrap: wrap;
      padding-top: 0.15rem;
      padding-bottom: 0;
      margin-top: -0.1rem;
      margin-left: -0.15rem;

      .market-bottom-tag-item {
        height: 0.4rem;
        line-height: normal;
        padding: 0 0.05rem;
        margin-top: 0.1rem;
        margin-left: 0.15rem;
        font-family: PingFangSC-Regular, 'PingFang SC';
        font-size: 0.2rem;
        font-weight: 400;
        border-radius: 0.04rem;
        color: var(--textColor);
        border: 1px solid var(--borderColor);
        background-color: var(--backgroundColor);
      }
    }

    // 发布/截止时间--文本
    .market-date-text {
      height: 0.33rem;
      line-height: 0.33rem;
      margin-top: 0.1rem;
      font-size: 0.24rem;
      font-weight: 400;
      color: #999;
    }
  }
</style>
